import iyfaaoPrice from "./pricelist"; 

const iyfaoGroupCat = {
    "Painting" :{
        "Watercolor (free topic)" : {
                1:{
                "id":1,"number":"PW1", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["PW1"],"cashPrize":iyfaaoPrice["PW1"]*5
                },
                2:{
                "id":2,"number":"PW2", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["PW2"],"cashPrize":iyfaaoPrice["PW2"]*5
                },
                3:{
                "id":3,"number":"PW3", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["PW3"],"cashPrize":iyfaaoPrice["PW3"]*5
                },
                4:{
                "id":4,"number":"PW4", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["PW4"],"cashPrize":iyfaaoPrice["PW4"]*5
                },
                5:{
                "id":5,"number":"PW5", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["PW5"],"cashPrize":iyfaaoPrice["PW5"]*5
                },
                6:{
                "id":6,"number":"PW6", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["PW6"],"cashPrize":iyfaaoPrice["PW6"]*5
                },
        },   
        "Pastel (free topic)" : {			
            1:{
                "id":1,"number":"PP1", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["PP1"],"cashPrize":iyfaaoPrice["PP1"]*5
                },
                2:{
                "id":2,"number":"PP2", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["PP2"],"cashPrize":iyfaaoPrice["PP2"]*5
                },
                3:{
                "id":3,"number":"PP3", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["PP3"],"cashPrize":iyfaaoPrice["PP3"]*5
                },
                4:{
                "id":4,"number":"PP4", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["PP4"],"cashPrize":iyfaaoPrice["PP4"]*5
                },
                5:{
                "id":5,"number":"PP5", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["PP5"],"cashPrize":iyfaaoPrice["PP5"]*5
                },
                6:{
                "id":6,"number":"PP6", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["PP6"],"cashPrize":iyfaaoPrice["PP6"]*5
                },
        },
        "Ink Wash (free topic)" : {			
            1:{
                "id":1,"number":"PI1", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["PI1"],"cashPrize":iyfaaoPrice["PI1"]*5
                },
                2:{
                "id":2,"number":"PI2", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["PI2"],"cashPrize":iyfaaoPrice["PI2"]*5
                },
                3:{
                "id":3,"number":"PI3", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["PI3"],"cashPrize":iyfaaoPrice["PI3"]*5
                },
                4:{
                "id":4,"number":"PI4", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["PI4"],"cashPrize":iyfaaoPrice["PI4"]*5
                },
                5:{
                "id":5,"number":"PI5", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["PI5"],"cashPrize":iyfaaoPrice["PI5"]*5
                },
                6:{
                "id":6,"number":"PI6", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["PI6"],"cashPrize":iyfaaoPrice["PI6"]*5
                },
        
        },
        "Sketch (free topic)" : {			
            1:{
                "id":1,"number":"PS1", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["PS1"],"cashPrize":iyfaaoPrice["PS1"]*5
                },
                2:{
                "id":2,"number":"PS2", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["PS2"],"cashPrize":iyfaaoPrice["PS2"]*5
                },
                3:{
                "id":3,"number":"PS3", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["PS3"],"cashPrize":iyfaaoPrice["PS3"]*5
                },
                4:{
                "id":4,"number":"PS4", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["PS4"],"cashPrize":iyfaaoPrice["PS4"]*5
                },
                5:{
                "id":5,"number":"PS5", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["PS5"],"cashPrize":iyfaaoPrice["PS5"]*5
                },
                6:{
                "id":6,"number":"PS6", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["PS6"],"cashPrize":iyfaaoPrice["PS6"]*5
                },
        
        },       
        "Oil (free topic)" : {			
            1:{
                "id":1,"number":"PO1", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["PO1"],"cashPrize":iyfaaoPrice["PO1"]*5
                },
                2:{
                "id":2,"number":"PO2", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["PO2"],"cashPrize":iyfaaoPrice["PO2"]*5
                },
                3:{
                "id":3,"number":"PO3", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["PO3"],"cashPrize":iyfaaoPrice["PO3"]*5
                },
                4:{
                "id":4,"number":"PO4", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["PO4"],"cashPrize":iyfaaoPrice["PO4"]*5
                },
                5:{
                "id":5,"number":"PO5", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["PO5"],"cashPrize":iyfaaoPrice["PO5"]*5
                },
                6:{
                "id":6,"number":"PO6", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["PO6"],"cashPrize":iyfaaoPrice["PO6"]*5
                },
        },
        "Acrylic (free topic)" : {			
            1:{
                "id":1,"number":"PA1", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["PA1"],"cashPrize":iyfaaoPrice["PA1"]*5
                },
                2:{
                "id":2,"number":"PA2", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["PA2"],"cashPrize":iyfaaoPrice["PA2"]*5
                },
                3:{
                "id":3,"number":"PA3", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["PA3"],"cashPrize":iyfaaoPrice["PA3"]*5
                },
                4:{
                "id":4,"number":"PA4", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["PA4"],"cashPrize":iyfaaoPrice["PA4"]*5
                },
                5:{
                "id":5,"number":"PA5", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["PA5"],"cashPrize":iyfaaoPrice["PA5"]*5
                },
                6:{
                "id":6,"number":"PA6", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["PA6"],"cashPrize":iyfaaoPrice["PA6"]*5
                },
        }
    },

    "Theme" :{
        "Your Protagonist (draw your favourite film star, celebrity, or comic / anime / gamplay characters, Any material and style)" : {
            1:{
                "id":1,"number":"TE1", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["TE1"],"cashPrize":iyfaaoPrice["TE1"]*5
                },
                2:{
                "id":2,"number":"TE2", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["TE2"],"cashPrize":iyfaaoPrice["TE2"]*5
                },
                3:{
                "id":3,"number":"TE3", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["TE3"],"cashPrize":iyfaaoPrice["TE3"]*5
                },
                4:{
                "id":4,"number":"TE4", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["TE4"],"cashPrize":iyfaaoPrice["TE4"]*5
                },
                5:{
                "id":5,"number":"TE5", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["TE5"],"cashPrize":iyfaaoPrice["TE5"]*5
                },
                6:{
                "id":6,"number":"TE6", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["TE6"],"cashPrize":iyfaaoPrice["TE6"]*5
                },
        },  
        // "Travelling" : {			
        //     1:{
        //         "id":1,"number":"TT1", "name":"Debut", "des":"Age 7 or below",  "price":55
        //         },
        //         2:{
        //         "id":2,"number":"TT2", "name":"Junior	", "des":"Age 7 to 9", "price":55
        //         },
        //         3:{
        //         "id":3,"number":"TT3", "name":"Emerging", "des":"Age 9 to 12","price":55
        //         },
        //         4:{
        //         "id":4,"number":"TT4", "name":"Youth","des":"Age 12 to 15", "price":65
        //         },
        //         5:{
        //         "id":5,"number":"TT5", "name":"Young Artist","des":"Age 15 to 18", "price":65
        //         },
        //         6:{
        //         "id":6,"number":"TT6", "name":"Artist","des":"Age 18 or above", "price":75
        //         },
        
        // },
        // "Dream" : {			
        //     1:{
        //         "id":1,"number":"TD1", "name":"Debut", "des":"Age 7 or below",  "price":55
        //         },
        //         2:{
        //         "id":2,"number":"TD2", "name":"Junior	", "des":"Age 7 to 9", "price":55
        //         },
        //         3:{
        //         "id":3,"number":"TD3", "name":"Emerging", "des":"Age 9 to 12","price":55
        //         },
        //         4:{
        //         "id":4,"number":"TD4", "name":"Youth","des":"Age 12 to 15", "price":65
        //         },
        //         5:{
        //         "id":5,"number":"TD5", "name":"Young Artist","des":"Age 15 to 18", "price":65
        //         },
        //         6:{
        //         "id":6,"number":"TD6", "name":"Artist","des":"Age 18 or above", "price":75
        //         },
        
        // },       
        
    },

    "Colouring" :{
        "Preschool Group" : {
            1:{
                "id":1,"number":"C1", "name":"Debut", "des":"Age 4 or below",  "price":47
                },
                2:{
                "id":2,"number":"C2", "name":"Junior	", "des":"Age 4 to 5", "price":47
                },
                3:{
                "id":3,"number":"C3", "name":"Emerging", "des":"Age 5 to 8","price":47
                },
            
        },
       
    },

    "Sculpturing" :{
        "Ceremics (free topic)" : {
            1:{
                "id":1,"number":"SC1", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["SC1"],"cashPrize":iyfaaoPrice["SC1"]*5
                },
                2:{
                "id":2,"number":"SC2", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["SC2"],"cashPrize":iyfaaoPrice["SC2"]*5
                },
                3:{
                "id":3,"number":"SC3", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["SC3"],"cashPrize":iyfaaoPrice["SC3"]*5
                },
                4:{
                "id":4,"number":"SC4", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["SC4"],"cashPrize":iyfaaoPrice["SC4"]*5
                },
                5:{
                "id":5,"number":"SC5", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["SC5"],"cashPrize":iyfaaoPrice["SC5"]*5
                },
                6:{
                "id":6,"number":"SC6", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["SC6"],"cashPrize":iyfaaoPrice["SC6"]*5
                },
        }, 
        "Handcraft (free topic)" : {			
            1:{
                "id":1,"number":"SH1", "name":"Debut", "des":"Age 7 or below",  "price":iyfaaoPrice["SH1"],"cashPrize":iyfaaoPrice["SH1"]*5
                },
                2:{
                "id":2,"number":"SH2", "name":"Junior	", "des":"Age 7 to 9", "price":iyfaaoPrice["SH2"],"cashPrize":iyfaaoPrice["SH2"]*5
                },
                3:{
                "id":3,"number":"SH3", "name":"Emerging", "des":"Age 9 to 12","price":iyfaaoPrice["SH3"],"cashPrize":iyfaaoPrice["SH3"]*5
                },
                4:{
                "id":4,"number":"SH4", "name":"Youth","des":"Age 12 to 15", "price":iyfaaoPrice["SH4"],"cashPrize":iyfaaoPrice["SH4"]*5
                },
                5:{
                "id":5,"number":"SH5", "name":"Young Artist","des":"Age 15 to 18", "price":iyfaaoPrice["SH5"],"cashPrize":iyfaaoPrice["SH5"]*5
                },
                6:{
                "id":6,"number":"SH6", "name":"Artist","des":"Age 18 or above", "price":iyfaaoPrice["SH6"],"cashPrize":iyfaaoPrice["SH6"]*5
                },
        
        },
      
    },

}

export default iyfaoGroupCat;